// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"1bd55bcf","453":"a5173c3c"}[chunkId] + ".chunk.js";
};